export default "__VITE_ASSET__DnX$WW6t__"